import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { AppBarComponent } from '../app-bar/app-bar.component';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, AppBarComponent],
  templateUrl: './shell.component.html',
})
export class ShellComponent {}
